// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yJD1","label":"styles_label__3grmt"};